import React from "react";
import AuditRecordsPageContainer from './AuditRecordsPageContainer';

export class AuditRecordsPage extends React.Component{
    render(){
        return (
            <AuditRecordsPageContainer { ...this.props} />
        )
    }
}